import React from 'react';
import List from 'containers/rest/List';
import RestFieldItem from 'components/RestField/RestFieldItem';
import ActionGroup from 'components/RestActions/ActionGroup';
import EditButton from 'components/RestActions/EditButton';
import DeleteButton from 'components/RestActions/DeleteButton';

const LanguagesList = props => (
  <List {...props} resource="languages">
    <RestFieldItem source="name" header="languages.name" />
    <RestFieldItem source="description" header="languages.description" />
    <RestFieldItem source="priority" header="languages.priority" />
    <RestFieldItem source="isActive" header="languages.isActive" />
    <ActionGroup>
      <EditButton />
      <DeleteButton />
    </ActionGroup>
  </List>
);

LanguagesList.propTypes = {};

export default LanguagesList;
